import { trpc } from '@tencent/tpro_rmonitor_web_server_url_token';
import { isEmpty } from 'lodash';
import { get, uniqBy } from 'lodash-es';
import { observable, makeObservable } from 'mobx';
import { getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { getProductId } from '@/infrastructure/product-info';
import { NumberType } from '@/presentation/components/form/components/select-number';
import { TagInfo } from '@/presentation/pages/setting/tag-manage/api';
import { getColorLabel } from '@/presentation/pages/setting/tag-manage/columns';
import { TAG_COLOR_INFO } from '@/presentation/pages/setting/tag-manage/config';
import { stores } from '@/presentation/store';
import {
  ExOption,
  FIELD_ALL,
  Option,
  TapdStatus,
  EMPTY_USER,
  FieldKey,
  AppVersionOperator, Zone,
} from '@/proto/field';
import { MetricType } from '@/proto/metric';
import { basicService } from '@/service/basic';
import { CustomFieldValue } from '../components/form/components/custom-fields';

export type ProcessorItem = {
  appId: string;
  platformId: number;
  type: number;
  userId: string;
  registerTime: string;
  newUserId: string;
};

// 暂时不知道这个结构是啥，先保留
// @ts-ignore
export type HotPluginVersionBean = any;

export type IssueVersion = {
  appId: string;
  platformId: number;
  productVersion: string;
  enable: string;
  enableAutoUpgrade: boolean;
  isShow: boolean;
  sdkVersion: string;
  hotpatchVersions: string[];
  hotPluginVersionBeans: HotPluginVersionBean[];
};

export type IssueTag = {
  appId: string;
  isShow: number;
  platFormId: string;
  tagId: string;
  tagName: string;
};

export interface IssueSelectData {
  newTagList: IssueTag[];
  bundleIdList: string[];
  channelList: string[];
  cpuInfos: string[];
  ftNames: string[];
  processorList: ProcessorItem[];
  tagList: IssueTag[];
  versionList: IssueVersion[];
}

export type IssueFilterItem = {
  options: Option[] | ExOption[];
};

export interface IssueFilterOptions {
  [key: string]: IssueFilterItem
}

export interface IssueFilterParams {
  stack?: {values: string[], mode: string}
  customDate?: string;
  rows?: number;
  search?: string;
  searchType?: string;
  sceneDataLabels?: string[] | string;
  start?: number,
  version?: any;
  date?: string;
  tagList?: string;
  newTagList?: string[];
  tagColor?: string;
  tagColors?: string[];
  status?: string;
  issueStatus?: string[];
  processor?: string;
  tapdHandler?: string[];
  channelId?: string;
  bundleId?: string;
  ftName?: string;
  exceptionTypeList?: string;
  startDateStr?: string;
  endDateStr?: string;
  sortField?: string;
  sortOrder?: string;
  deviceId?: string;
  cpuArch?: string;
  issueId?: string;
  crashId?: string;
  contectInfo?: string;
  errorType?: string;
  hardware?: string;
  osVersion?: string;
  detail?: string;
  processName?: string;
  threadName?: string;
  teamName?: string;
  platform?: string;
  dateRange?: any;
  appIsFlutter?: boolean;
  userTagInfos?: string;
  random?: number;
  appInBacks?: string[];
  bizExtendInfo?: CustomFieldValue[];
  bizExtendInfoCompare?: CustomFieldValue[];
  isCompareOpen?: boolean;
  topData?: string;
  accurateDate?: string;
  accurateDateCompare?: string;
  filters?: any;
  appVersionOperator?: string;
  timeQuick?: string;
  timeWindow?: number;
  timeType?: 'report' | 'occur';
  minAppVersion?: string;
  maxAppVersion?: string;
  wildcardAppVersion?: string;
  optionalFilters?: string;
  cpuArchitecture?: string;
  detailMode?: string;
  isParticiple?: string;
  tapdStatus?: string |string[];
  launchDuration?: NumberType;
  freeMem?: NumberType;
  sdkVersion?: string;
  linkages?: string[] | string;
  clusterStackType?: trpc.rmonitor.web_server.ClusterStackType;
  topNum?: string;
  startDateStrCompare?: string;
  endDateStrCompare?: string;
  buildNumber?: string[];
  newTagListOperator?: string;
  tapdHandlerOperator?: string;
  issueStatusOperator?: string;
  tapdStatusOperator?: string;
  tagColorOperator?: string;
  clusterStackTypeOperator?: string;
  newTagListOperatorConvert?: boolean;
  tapdHandlerOperatorConvert?: boolean;
  issueStatusOperatorConvert?: boolean;
  tapdStatusOperatorConvert?: boolean;
  tagColorOperatorConvert?: boolean;
  clusterStackTypeOperatorConvert?: boolean;
}

export interface IssueFilterCompareParams extends IssueFilterParams {
  appInBacksCompare?: string[];
  bundleIdCompare?: string;
  channelIdCompare?: string;
  contectInfoCompare?: string;
  cpuArchCompare?: string;
  crashIdCompare?: string;
  deviceIdCompare?: string;
  hardwareCompare?: string;
  issueIdCompare?: string;
  osVersionCompare?: string;
  processNameCompare?: string;
  threadNameCompare?: string;
  timeRangeCompare?: string[];
  versionCompare?: string[];
  customDateCompare?: string;
  timeTypeCompare?: 'report' | 'occur';
  minAppVersionCompare?: string;
  maxAppVersionCompare?: string;
  wildcardAppVersionCompare?: string;
  appVersionOperatorCompare?: AppVersionOperator;
  timeQuickCompare?: string;
  cpuArchitectureCompare?: string;
  sdkVersionCompare?: string;
  rom?: string;
  romCompare?: string;
  shiplyTag?: string;
  abTestTag?: string;
  shiplyTagCompare?: string;
  abTestTagCompare?: string;
  startDateStrCompare?: string;
  endDateStrCompare?: string;
  buildNumberCompare?: string[];
}

// const initFilterParams: IssueFilterParams = {
//   searchType: 'errorType',
//   start: 0,
//   date: 'last_7_day',
//   sortField: 'uploadTime',
//   sortOrder: 'desc',
//   version: FIELD_ALL,
//   platform: FIELD_ALL,
// };

export const INIT_FIELD_OPTIONS: IssueFilterOptions = {
  reportType: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: '全生命周期', value: '1' },
      { label: '十分钟', value: '2' },
    ],
  },
  netType: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: 'wifi', value: 'wifi' },
      { label: 'mobile', value: 'mobile' },
    ],
  },
  frontState: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: '前台', value: 'front_end' },
      { label: '后台', value: 'back_end' },
    ],
  },
  version: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  status: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: '未处理', value: '0' },
      { label: '已处理', value: '1' },
      { label: '处理中', value: '2' },
      { label: '拒绝', value: '7' },
      { label: '挂起', value: '8' },
    ],
  },
  appInBack: {
    options: [
      { label: '所有', value: '0' },
      { label: '前台', value: '3' },
      { label: '后台', value: '2' },
      // { label: '未知', value: '1' },
    ],
  },
  tapdStatus: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: '新', value: TapdStatus.New },
      { label: '未提单', value: TapdStatus.Unassigned },
      { label: '接受/处理', value: TapdStatus.InProgress },
      { label: '已处理', value: TapdStatus.Handled },
      { label: '已分配', value: TapdStatus.Assigned },
      { label: '已解决', value: TapdStatus.Resolved },
      { label: '已验证', value: TapdStatus.Verified },
      { label: '重新打开', value: TapdStatus.Reopened },
      { label: '已拒绝', value: TapdStatus.Rejected },
      { label: '已关闭', value: TapdStatus.Closed },
      { label: '待确认的', value: TapdStatus.Unconfirmed },
      { label: '计划中', value: TapdStatus.Planning },
      { label: '需要再次说明', value: TapdStatus.Feedback },
      { label: '已了解', value: TapdStatus.Acknowledged },
      { label: '挂起', value: TapdStatus.Suspended },
      { label: '延期', value: TapdStatus.Postponed },
      { label: 'TM审核', value: TapdStatus.TMAudited },
      { label: 'PMM审核', value: TapdStatus.PMMAudited },
      { label: 'PM审核', value: TapdStatus.PMAudited },
      { label: 'QA审核', value: TapdStatus.QAAudited },
    ],
  },
  platform: {
    options: [
      { label: '所有', value: FIELD_ALL },
      { label: 'Android', value: 'Android' },
      { label: 'iOS', value: 'iPhone' },
    ],
  },
  processor: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  tagList: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  newTagList: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  bundleId: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  channelId: {
    options: [
    ],
  },
  ftNames: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
  cpuInfos: {
    options: [
      { label: '所有', value: FIELD_ALL },
    ],
  },
};

export const CRASH_SCENE_DATA_LABELS_OPTIONS = [
  { label: '所有', value: FIELD_ALL },
  { label: '日志', value: 'log' },
  { label: 'FD信息', value: 'fileDescriptor' },
  { label: '进程信息', value: 'processInfo' },
  { label: '页面跟踪', value: 'martianlog' },
];

export const ANR_SCENE_DATA_LABELS_OPTIONS = [
  { label: '所有', value: FIELD_ALL },
  { label: '调度时序图', value: 'messageScheduleDiagram' },
  { label: '日志', value: 'log' },
  { label: 'FD信息', value: 'fileDescriptor' },
  { label: '进程信息', value: 'processInfo' },
  { label: 'ANR_INFO', value: 'anrInfo' },
  { label: 'ANR Trace', value: 'anrTrace' },
  { label: '页面跟踪', value: 'martianlog' },
];
export const ERROR_FOOM_SCENE_DATA_LABELS_OPTIONS = [
  { label: '所有', value: FIELD_ALL },
  { label: '日志', value: 'log' },
  { label: '页面跟踪', value: 'martianlog' },
];

const getSelectorDatas = async (appId: string, pid: string | number) => {
  const types = 'version,member,bundle,tag,channel,ft,cpu';
  const querys = {
    types,
    appId,
    pid,
  };
  try {
    return await getAxios().get(`/${API_PREFIX}/api/app/selector-data`, {
      params: querys,
    });
  } catch (e) {
    return {};
  }
};

const GetMonitorFieldDistinctData = async (
  field: string,
  zone: string,
): Promise<string[]> => basicService.getMonitorFieldDistinctData({
  productID: getProductId(),
  dim: field,
  type: zone,
  endTime: null,
  startTime: null,
  optionalFilters: [],
  limit: 5000,
});

export const getMonitorType = (type: MetricType): Zone => {
  const typeObj = {
    [MetricType.TYPE_CRASH]: Zone.Crash,
    [MetricType.TYPE_ANDROID_FOOM]: Zone.AndroidFoom,
    [MetricType.TYPE_ERROR]: Zone.Error,
    [MetricType.TYPE_ANR]: Zone.AndroidANR,
  };
  return get(typeObj, type) || Zone.Crash;
};

const getTags = (appId: string, pid: string | number) => {
  const querys = {
    appId,
    pid,
  };
  return getAxios().get(`/${API_PREFIX}/api/tag/list`, {
    params: querys,
  });
};

export class IssueStore {
  /**
   * 下拉框中用到的下拉选项参数
   */
  public options: Map<string, IssueFilterOptions> = new Map<string, IssueFilterOptions>();

  constructor() {
    makeObservable(this, {
      options: observable,
    });
  }

  public getOptions = async (type?: MetricType, forceUpdate = false) => {
    const key = type ? `${getProductId()}_${type}` : getProductId();
    let options = this.options.get(key);
    if (options && !forceUpdate) {
      return options;
    }

    options = await this.loadOptions(type);
    this.options.set(key, options);
    return options;
  };

  public getFieldOptions = (field: string) => {
    const key = getProductId();
    const options = this.options.get(key);
    return options?.[field].options.map(item => ({ label: item.label, value: item.value })) ?? [];
  };

  public updateTagsOptions = async (tagList: TagInfo[], forceUpdate = false) => {
    const key = getProductId();
    if (forceUpdate || !this.options.get(key)) {
      const options = await this.loadOptions();
      this.options.set(key, options);
    }
    const options = { ...this.options.get(key), ...this.filterTagsOptions(tagList) };
    this.options.set(key, options);
  };

  public loadOptions = async (type?: MetricType) => {
    const appId = getProductId();
    let appVersionOptions: Option[] = [];
    let tagOptions: Option[] = [];
    if (type) {
      const monitorType = getMonitorType(type);
      const tagsRes = await getTags(appId, stores.ProductStore.pid);
      const tags = get(tagsRes, 'data.unsystemTagArr', []);
      const [
        appVersionRes,
        tagListRes,
      ] = await Promise.all([
        FieldKey.AppVersion,
        'tags',
      ].map(field => GetMonitorFieldDistinctData(field, monitorType)));
      appVersionOptions = this.formatOptions(appVersionRes);
      tagOptions = tags.filter((tag: { tagName: string; }) => tagListRes.includes(tag.tagName));
    }
    const selectorRes: Record<string, any> = await getSelectorDatas(appId, stores.ProductStore.pid);
    const selectorData = get(selectorRes, 'data.data.datas', {});
    selectorData.newTagList = tagOptions;

    return this.filterToSelectOptions(selectorData, {
      appVersionOptions,
      cpuArchitectureOptions: [],
      cpuArcOptions: [],
      sdkVersionOptions: [],
      channelIdOptions: [],
      bundleIdOptions: [],
    });
  };

  private filterTagsOptions = (tags: TagInfo[]): IssueFilterOptions => ({
    newTagList: {
      options: [
        {
          label: '所有',
          value: FIELD_ALL,
        },
      ].concat(tags.map((item: TagInfo) => ({ label: item.tagName!, value: `${item.tagId}` }))),
    },
  });

  private formatOptions = (options: string[]) => options.map(item => ({ value: item, label: item }));

  private filterToSelectOptions = (
    selectData: IssueSelectData,
    optionsMap: Record<string, Option[]>,
  ): IssueFilterOptions => {
    const {
      processorList = [],
      tagList = [],
      versionList = [],
      ftNames = [],
      newTagList = [],
    } = selectData;

    return {
      ...INIT_FIELD_OPTIONS,
      // 质量版本下拉数据
      appVersion: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...optionsMap.appVersionOptions,
        ],
      },
      version: {
        options: (() => {
          const results: Option[] = [];
          versionList.filter(item => !isEmpty(item.productVersion)).forEach((item: IssueVersion) => {
            results.push({
              label: parseInt(item.enable, 10) === 0 ? `${item.productVersion}(已关闭)` : item.productVersion,
              value: encodeURIComponent(item.productVersion),
            });
            if (Array.isArray(item.hotpatchVersions) && item.hotpatchVersions.length > 0) {
              item.hotpatchVersions.forEach((hotpatchVersion) => {
                results.push({
                  label:
                    parseInt(item.enable, 10) === 0
                      ? `${item.productVersion}(hotpatch: ${hotpatchVersion})(已关闭)`
                      : `${item.productVersion}(hotpatch: ${hotpatchVersion})`,
                  value: encodeURIComponent(`${item.productVersion}[${hotpatchVersion}]`),
                });
              });
            }
            if (Array.isArray(item.hotPluginVersionBeans) && item.hotPluginVersionBeans.length > 0) {
              item.hotPluginVersionBeans.forEach((pluginVersionBean) => {
                if (
                  Array.isArray(pluginVersionBean.hotPluginVersion)
                  && pluginVersionBean.hotPluginVersion.length > 0
                ) {
                  pluginVersionBean.hotPluginVersion.forEach((hotPluginVersion: any) => {
                    results.push({
                      label:
                        parseInt(item.enable, 10) === 0
                          ? `${item.productVersion}(plugin: ${pluginVersionBean.hotPluginId}--${hotPluginVersion})(已关闭)`
                          : `${item.productVersion}(plugin: ${pluginVersionBean.hotPluginId}--${hotPluginVersion})`,
                      value: encodeURIComponent(`${item.productVersion}[${pluginVersionBean.hotPluginId}[${hotPluginVersion}]]`),
                    });
                  });
                }
              });
            }
          });
          results.unshift({
            label: '所有',
            value: FIELD_ALL,
          });
          return results;
        })(),
      },
      processor: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          {
            label: '空',
            value: EMPTY_USER,
          },
        ].concat(uniqBy(processorList, 'newUserId').map(item => ({
          label: item.newUserId,
          value: item.newUserId,
        }))),
      },
      tagList: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
        ].concat(tagList.map(item => ({ label: item.tagName, value: `${item.tagId}` }))),
      },
      bundleId: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...optionsMap.bundleIdOptions,
        ],
      },
      channelId: {
        options: [
          ...optionsMap.channelIdOptions,
        ],
      },
      ftNames: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
        ].concat(ftNames.map(item => ({ label: item, value: encodeURIComponent(item) }))),
      },
      cpuInfos: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...optionsMap.cpuArcOptions,
        ],
      },
      cpuArchitectureInfos: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...optionsMap.cpuArchitectureOptions,
        ],
      },
      sdkVersion: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...optionsMap.sdkVersionOptions,
        ],
      },
      newTagList: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...newTagList.map(item => ({ value: item.tagId, label: item.tagName })),
        ],
      },
      tagColor: {
        options: [
          {
            label: '所有',
            value: FIELD_ALL,
          },
          ...TAG_COLOR_INFO.map(item => ({
            label: getColorLabel(item.color, true),
            value: item.color,
          })),
        ],
      },
    };
  };
}
export enum IssueTabEnum {
  List='0',
  StatisticalDistribution='1'
}
